import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logoBlack from "../../assets/LogoBlack.png";
import { FaUser } from "react-icons/fa";
import ProfilePopup from "../popup/ProfilePopup"; // ✅ Import ProfilePopup

const Header = ({ logoSize = 120 }) => { // ✅ Remove onOpenPopup prop
  const location = useLocation();
  const navigate = useNavigate();

  const [showNav, setShowNav] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false); // ✅ Local state

  const menuItems = [
    { name: "HOME", label: "Home", target: "hero" },
    { name: "SCENTS", label: "Scents", target: "products" },
    { name: "ABOUT US", label: "About Us", target: "brand" },
    { name: "SOCIALS", label: "Socials", target: "footer" },
  ];

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }, 300);
      setMenuOpen(false);
      return;
    }
    const section = document.getElementById(id);
    if (!section) return;
    const headerOffset = 80;
    const y = section.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => setShowNav(window.scrollY <= 120);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSocialClick = (social) => {
    setMenuOpen(false);
    if (social === "Instagram") {
      window.open("https://www.instagram.com/perfumebysorin/", "_blank");
    } else if (social === "TikTok") {
      window.open("https://www.tiktok.com/@perfumebysorin", "_blank");
    }
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 1024px) {
            .nav-container {
              gap: 40px !important;
            }
          }
          @media (max-width: 768px) {
            .nav-container {
              gap: 24px !important;
            }
          }
          @media (max-width: 640px) {
            .nav-container {
              gap: 16px !important;
            }
          }

          .nav-button {
            color: #000;
            transition: color 0.3s ease;
          }
          .nav-button:hover {
            color: #dc814c;
          }
        `}
      </style>

      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#f7f7f5",
          zIndex: 9999,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            height: "70px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: "0 20px",
          }}
        >
          <button
            onClick={() => setMenuOpen(true)}
            style={{
              position: "absolute",
              left: "20px",
              fontSize: "1.5rem",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#000",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
            aria-label="Open menu"
          >
            ☰
          </button>

          <img
            src={logoBlack}
            alt="SORIN Logo"
            onClick={() => scrollToSection("hero")}
            style={{
              height: `${logoSize}px`,
              width: "auto",
              cursor: "pointer",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />

          {/* ✅ Profile Button - Open ProfilePopup */}
          <button
            onClick={() => setShowProfilePopup(true)}
            aria-label="Open profile"
            style={{
              position: "absolute",
              right: "20px",
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              padding: "8px",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => {
              const svg = e.currentTarget.querySelector("svg");
              if (svg) svg.style.color = "#dc814c";
            }}
            onMouseLeave={(e) => {
              const svg = e.currentTarget.querySelector("svg");
              if (svg) svg.style.color = "#000";
            }}
          >
            <FaUser size={20} color="#000" style={{ transition: "color 0.3s ease" }} />
          </button>
        </div>

        <div
          className="nav-container"
          style={{
            height: showNav ? "50px" : "0px",
            opacity: showNav ? 1 : 0,
            overflow: "hidden",
            transition: "all 0.3s ease",
            borderTop: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "56px",
          }}
        >
          {menuItems.map((item, i) => (
            <button
              key={i}
              className="nav-button"
              onClick={() => scrollToSection(item.target)}
              style={{
                background: "none",
                border: "none",
                fontFamily: "DM Serif Display, serif",
                fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
                cursor: "pointer",
                whiteSpace: "nowrap",
                color: "#000",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
            >
              {item.name}
            </button>
          ))}
        </div>
      </header>

      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 9998,
          }}
        />
      )}

      <aside
        style={{
          position: "fixed",
          top: 0,
          left: menuOpen ? 0 : "-400px",
          width: "360px",
          height: "100vh",
          backgroundColor: "#f1f1ef",
          padding: "36px 28px",
          borderRight: "1px solid #ddd",
          transition: "left 0.35s ease",
          zIndex: 9999,
          overflowY: "auto",
        }}
      >
        <button
          onClick={() => setMenuOpen(false)}
          style={{
            alignSelf: "flex-end",
            fontSize: "1.5rem",
            background: "none",
            border: "none",
            cursor: "pointer",
            marginBottom: "12px",
            color: "#000",
            transition: "color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
          aria-label="Close menu"
        >
          ✕
        </button>

        <p style={{ 
          fontFamily: "Georgia, serif", 
          fontSize: "0.95rem", 
          color: "#555", 
          marginBottom: "18px" 
        }}>
          SORIN — From Your Sun
        </p>

        {menuItems.map((item, i) => (
          <div
            key={i}
            onClick={() => scrollToSection(item.target)}
            style={{
              fontFamily: "DM Serif Display, serif",
              fontSize: "1.1rem",
              margin: "14px 0",
              cursor: "pointer",
              color: "#000",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
          >
            {item.label}
          </div>
        ))}

        <div
          onClick={() => handleSocialClick("Instagram")}
          style={{
            fontFamily: "DM Serif Display, serif",
            fontSize: "1.1rem",
            margin: "14px 0",
            cursor: "pointer",
            color: "#000",
            transition: "color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
        >
          Instagram
        </div>
        <div
          onClick={() => handleSocialClick("TikTok")}
          style={{
            fontFamily: "DM Serif Display, serif",
            fontSize: "1.1rem",
            margin: "14px 0",
            cursor: "pointer",
            color: "#000",
            transition: "color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#dc814c")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#000")}
        >
          TikTok
        </div>
      </aside>

      {/* ✅ Render ProfilePopup */}
      {showProfilePopup && (
        <ProfilePopup onClose={() => setShowProfilePopup(false)} />
      )}
    </>
  );
};

export default Header;